<template>
    <v-layout column align-center justify-center mt-5>
        <v-container>
            <v-row>
                <v-col>
                    <v-card 
                        flat 
                        :style = '`box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'
                        :loading = 'indicator.yg'
                        min-width = '320px'
                        class = 'mb-2'
                    >
                        <template v-slot:progress>
                            <v-progress-linear 
                                :color = '$store.getters.uiAccentIcon' 
                                height = '2' 
                                indeterminate
                            ></v-progress-linear>
                        </template>
                        <v-card-title class = 'py-2'>
                            <span class = 'headline font-weight-light'>OAuth-доступы</span>
                            <v-btn icon @click = 'inspectYG' class = 'ml-auto'><v-icon>mdi-refresh</v-icon></v-btn>
                        </v-card-title>
                        <v-divider :color = '$store.getters.uiAccent'></v-divider>
                        <v-card-text class = 'py-2 px-1'>
                            <v-list class = 'my-0 py-0'>
                                <v-skeleton-loader 
                                    v-if = '!yg.sources || yg.sources.length == 0'
                                    type = 'list-item-two-line'
                                ></v-skeleton-loader>
                                <template v-for = '(v, i) in yg.sources'>
                                    <v-list-item :key = 'i'>
                                        <v-list-item-action>
                                            <span class = 'caption'>{{v.provider}}</span>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{v.email}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <span v-if = 'v.reason === null' class = 'green--text caption'>Доступы корректны</span>
                                                <span v-else class = 'red--text caption'>Ошибка доступов: {{v.reason}}</span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-tooltip left>
                                                <template v-slot:activator = '{ on }'>
                                                    <v-btn icon @click = 'visibility_inspect = true; scanSources(v); sourceCursor = v;' v-on = 'on'>
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Проверить источники</span>
                                            </v-tooltip>
                                        </v-list-item-action>
                                        <v-list-item-action>
                                            <v-icon v-if = 'v.reason === null' color = 'success'>mdi-check-decagram</v-icon>
                                            <v-icon v-else color = 'error'>mdi-alert-decagram</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col>
                    <v-card 
                        flat 
                        :style = '`box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'
                        :loading = 'indicator.queue'
                        min-width = '320px'
                        class = 'mb-2'
                    >
                        <template v-slot:progress>
                            <v-progress-linear 
                                :color = '$store.getters.uiAccentIcon' 
                                height = '2' 
                                indeterminate
                            ></v-progress-linear>
                        </template>
                        <v-card-title class = 'py-2'>
                            <span class = 'headline font-weight-light'>Очереди задач</span>
                            <v-btn icon @click = 'inspectQueues' class = 'ml-auto'><v-icon>mdi-refresh</v-icon></v-btn>
                        </v-card-title>
                        <v-divider :color = '$store.getters.uiAccent'></v-divider>
                        <v-card-text class = 'py-2 px-1'>
                            <v-list class = 'my-0 py-0'>
                                <v-skeleton-loader 
                                    v-if = '!queues || queues.length == 0'
                                    type = 'list-item-two-line'
                                ></v-skeleton-loader>
                                <template v-for = '(v, i) in queues'>
                                    <v-list-item :key = 'i'>
                                        <v-list-item-action>
                                            <v-icon>mdi-cloud-outline</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{v.name.split('/').slice(-1)[0]}}</v-list-item-title>
                                            <v-list-item-subtitle>{{v.service}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action class = 'ml-2'>
                                            <v-chip label outlined>Задач: {{v.tasks.length}}</v-chip>
                                        </v-list-item-action>
                                        <v-list-item-action>
                                            <v-tooltip left>
                                                <template v-slot:activator = '{ on }'>
                                                    <v-btn icon @click = 'visibility_queues = true; queueCursor = v;' v-on = 'on'>
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Просмотреть задачи</span>
                                            </v-tooltip>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <dialog-fullscreen :visibility.sync = 'visibility_queues' :indicator = 'indicator.queue'>
            <template v-slot:title>{{queueCursor && queueCursor.name && queueCursor.name.split('/').slice(-1)[0]}}</template>
            <template v-slot:content>
                <v-container class = 'ma-0 pa-0'>
                    <v-list style = 'max-width: 720px;' class = 'mx-auto my-0 py-0'>
                        <v-row v-if = 'queueCursor && queueCursor.tasks && queueCursor.tasks.length == 0'>
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>В указанной очереди задач не обнаружено</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-row>
                        <template v-for = 't in orderArray(queueCursor.tasks, `created`, `desc`)'>
                            <v-row :key = 't.name'>
                                <v-col>
                                    <v-list-item link>
                                        <v-list-item-action><v-icon>mdi-firework</v-icon></v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{t.name.split('/').slice(-1)[0]}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <span :class = 't.dispatch_count > 0? `red--text`:`green--text`'>
                                                    {{t.dispatch_count > 0? `Выполняется с ошибками`:`В очереди на выполнение`}}
                                                </span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <span class = 'caption'>{{getPrintableTimestamp(t.created)}}</span>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider inset :key = '`divider_${t.name}`'></v-divider>
                                </v-col>
                            </v-row>
                        </template>
                    </v-list>
                </v-container>
            </template>
        </dialog-fullscreen>
        <dialog-fullscreen :visibility.sync = 'visibility_inspect' :indicator = 'indicator.inspect'>
            <template v-slot:title>Источники данных</template>
            <template v-slot:content>
                <v-container class = 'ma-0 pa-0'>
                    <v-list style = 'max-width: 720px;' class = 'mx-auto my-0 py-0'>
                        <v-skeleton-loader
                            v-if = 'indicator.inspect'
                            type = 'list-item-two-line'
                        ></v-skeleton-loader>
                        <v-row v-if = 'sources.length == 0 && !indicator.inspect'>
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>К указанному аккаунту не привязан ни один источник</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-row>
                        <template v-for = 's in sources'>
                            <v-row :key = 's.source_id'>
                                <v-col>
                                    <v-list-item link>
                                        <v-list-item-action><span style = 'text-transform: uppercase;'>{{s.source_type_id}}</span></v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{s.source_name}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <a :href = '`https://123.artics.ru/p/${s.project_id}`' target = '_blank'>{{s.project_name}}</a>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-tooltip bottom allow-overflow>
                                                <template v-slot:activator = '{on}'>
                                                    <v-icon :color = 's.actual? "success":"error"' v-on = 'on'>
                                                        {{s.actual? "mdi-check": "mdi-alert"}}
                                                    </v-icon>
                                                </template>
                                                <span>{{s.actual? `Доступы корректны`: `Доступы к ресурсу отозваны для аккаунта ${sourceCursor.email}`}}</span>
                                            </v-tooltip>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider inset :key = '`divider_${s.source_id}`'></v-divider>
                                </v-col>
                            </v-row>
                        </template>
                    </v-list>
                </v-container>
            </template>
        </dialog-fullscreen>
    </v-layout>
</template>

<script>

    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
    import { orderBy } from 'lodash-es'
    import dayjs from 'dayjs'
    import 'dayjs/locale/ru'

    export default {
        name: 'Monitor',
        components: {'dialog-fullscreen': DialogFullscreen},
        data: () => ({
            indicator: {
                yg: false,
                inspect: false,
                queue: false
            },
            yg: [],
            sourceCursor: {},
            queueCursor: {},
            sources: [],
            queues: [],
            visibility_inspect: false,
            visibility_queues: false,
        }),
        methods: {
            orderArray(arr, key, ord) {
                return orderBy(arr, key, ord)
            },
            getPrintableTimestamp(ts) {
                return dayjs.unix(ts).format('D MMM HH:mm:ss')
            },
            scanSources(source) {
                this.indicator.inspect = true
                this.sources = []
                this.$http.post(
                    this.$store.getters.endpoint + '/db/su/inspect/sources', {
                        parent: source.email,
                        type: source.provider
                    }, {
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then( (r) => {
                    this.indicator.inspect = false
                    this.sources = orderBy(r.body.data, 'actual', 'asc')
                })
            },
            inspectQueues() {
                this.indicator.queue = true
                this.queues = []
                this.$http.post(
                    this.$store.getters.endpoint + '/db/su/inspect/queues', {
                        include_tasks: true,
                        working_queues: true
                    }, {
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then( (r) => {
                    this.indicator.queue = false
                    this.queues = orderBy(r.body.data, 'name', 'asc')
                })
            },
            inspectYG() {
                this.indicator.yg = true
                this.$http.post(
                    'https://oauth-worker-dot-trying-artics-pipeline.appspot.com/connect/check/yg', {}, {
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then( (r) => {
                    this.indicator.yg = false
                    this.yg = r.body
                })
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.inspectYG()
                vm.inspectQueues()
            })
        }
    }
</script>